import { namespace } from 'wsm-tagging-utils';

const runEventHandlerDecorator = (win) => {
	namespace(win, 'DDC.tracking.framework.runtime');

	const {
		DDC: { tracking }
	} = win;

	/**
	 * EventHandlerDecorators enables functional composition by providing a means
	 * of decorating existing EventHandlers with additional behavior. By default
	 * all operations simply defer actual work to the supplied delegate.
	 *
	 * Subclasses are expected to override the appropriate methods to add decorated
	 * behavior.
	 *
	 * @see https://sourcemaking.com/design_patterns/decorator
	 * @see https://sourcemaking.com/design_patterns/chain_of_responsibility
	 */
	tracking.framework.runtime.EventHandlerDecorator = class extends (
		tracking.framework.runtime.EventHandler
	) {
		/**
		 * Creates a tracking.framework.runtime.EventHandlerDecorator object
		 *
		 * @param {Object} window The window object
		 * @param {tracking.framework.runtime.Page} page A Page instance for page related queries
		 * @param {tracking.framework.runtime.Form} form A Form instance for form related queries
		 * @param {tracking.framework.runtime.EventHandler} delegate The EventHandler implementation to which all interface
		 *                    operations are delegated
		 */
		constructor(window, page, delegate, form) {
			super(window, page, form);
			this.delegate = delegate;
		}
	};

	tracking.framework.runtime.EventHandlerDecorator.prototype.logCategory =
		'ws-tagging:EventHandlerDecorator';

	/**
	 * Update EventHandlerDecorator handler methods to call its chained delegate with event data by default
	 */
	const eventHandlerPrototype =
		tracking.framework.runtime.EventHandler.prototype;
	Object.keys(eventHandlerPrototype)
		.filter(
			(prop) =>
				prop.indexOf('handle') === 0 &&
				typeof eventHandlerPrototype[prop] === 'function'
		)
		.forEach((handlerMethodName) => {
			tracking.framework.runtime.EventHandlerDecorator.prototype[
				handlerMethodName
			] = function delegateHandler(eventData) {
				this.delegate[handlerMethodName](eventData);
			};
		});
};

export default runEventHandlerDecorator;
